module.exports = __webpack_public_path__ + "img/20210906-1630913532627735.18a058d5.png";